import { formatDistanceToNow } from "date-fns";
import type { CSSProperties } from "react";
import { COLORS, SPACE, TYPE } from "../theme/index.js";

type TimelineItemProps = {
  id: string;
  actor?: string;
  action: string;
  subject?: string;
  occurred_at: string;
  style?: CSSProperties;
};

export function TimelineItem({ actor, action, subject, occurred_at, style }: TimelineItemProps) {
  const when = formatDistanceToNow(new Date(occurred_at), { addSuffix: true });
  return (
    <div
      style={{
        display: "flex",
        gap: SPACE[3],
        padding: `${SPACE[3]}px 0`,
        borderBottom: `1px solid ${COLORS.border}`,
        ...style,
      }}
    >
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: COLORS.brand,
          flexShrink: 0,
          marginTop: 6,
        }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontSize: TYPE.size.sm, color: COLORS.text, lineHeight: 1.5 }}>
          {actor && <strong style={{ fontWeight: TYPE.weight.medium }}>{actor} </strong>}
          {action}
          {subject && (
            <>
              {" "}
              on <strong style={{ fontWeight: TYPE.weight.medium }}>{subject}</strong>
            </>
          )}
        </p>
        <span style={{ fontSize: TYPE.size.xs, color: COLORS.textDim }}>{when}</span>
      </div>
    </div>
  );
}
